module.exports = __webpack_public_path__ + "media/index-earthNetwork_1.26d19a14.mp4";